/**
 * Returns a new array with unique values from the given array, based on the specified key.
 * If no key is provided, unique items themselves are returned. Supports nested keys.
 *
 * @param {Array} arr - The array from which to extract unique values.
 * @param {string} [key=null] - The key to use for uniqueness, supports dot notation for nested keys.
 * @returns {Array} A new array containing only unique values based on the specified key.
 */

const getUniqueValueArray = (arr, key = null) => {
    const getValue = (item, key) => {
        if (!key) return item; // If key is not provided, return the item itself
        return key.split('.').reduce((obj, k) => obj?.[k], item); // Support for nested keys
    };

    return arr.reduce((acc, item) => {
        const value = getValue(item, key);
        if (!acc.some(existingItem => getValue(existingItem, key) === value)) {
            acc.push(item);
        }
        return acc;
    }, []);
};

export default getUniqueValueArray;